<template>
  <div id="sideNav">
    <el-menu
      router
      :default-active="$route.path"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
    >
      <el-menu-item index="/customer">
        <i class="el-icon-s-custom"></i>
        <span slot="title">客户管理</span>
      </el-menu-item>
      <el-menu-item index="/supplier">
        <i class="el-icon-truck"></i>
        <span slot="title">供应商管理</span>
      </el-menu-item>
      <el-submenu index="3">
        <span slot="title">
          <i class="el-icon-s-order"></i>
          <span>订单管理</span>
        </span>
        <el-menu-item-group>
          <el-menu-item index="/order">
            <i class="el-icon-edit-outline"></i>
            <span slot="title">订单信息</span>
          </el-menu-item>
          <el-menu-item index="/orderPlan">
            <i class="el-icon-date"></i>
            <span slot="title">生产计划</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="/formula">
        <i class="el-icon-water-cup"></i>
        <span slot="title">配方管理</span>
      </el-menu-item>
      <el-submenu index="4">
        <span slot="title">
          <i class="el-icon-truck"></i>
          <span>物流管理</span>
        </span>
        <el-menu-item-group>
          <el-menu-item index="/delivery">
            <i class="el-icon-top"></i>
            <span slot="title">送货单</span>
          </el-menu-item>
          <el-menu-item index="/delivery">
            <i class="el-icon-top"></i>
            <span slot="title">退货单</span>
          </el-menu-item>
          <el-menu-item index="4-1">
            <i class="el-icon-bottom"></i>
            <span slot="title">进货单</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="/device">
        <i class="el-icon-s-tools"></i>
        <span slot="title">设备管理</span>
      </el-menu-item>
      <el-submenu index="5">
        <span slot="title">
          <i class="el-icon-box"></i>
          <span>原料管理</span>
        </span>
        <el-menu-item-group>
          <el-menu-item index="/home/yarnType">
            <i class="el-icon-menu"></i>
            <span slot="title">胚纱类型</span>
          </el-menu-item>
          <el-menu-item index="/yarn">
            <i class="el-icon-box"></i>
            <span slot="title">纱支</span>
          </el-menu-item>
          <el-menu-item index="5-2">
            <i class="el-icon-top"></i>
            <span slot="title">染料</span>
          </el-menu-item>
          <el-menu-item index="5-3">
            <i class="el-icon-top"></i>
            <span slot="title">助剂</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-menu-item index="/stock">
        <i class="el-icon-setting"></i>
        <span slot="title">库存管理</span>
      </el-menu-item>
      <el-submenu index="6">
        <span slot="title">
          <i class="el-icon-s-finance"></i>
          <span>财务管理</span>
        </span>
        <el-menu-item-group>
          <el-menu-item index="/receivable">
            <i class="el-icon-money"></i>
            <span slot="title">应收帐款</span>
          </el-menu-item>
          <el-menu-item index="/payable">
            <i class="el-icon-coin"></i>
            <span slot="title">应付帐款</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style scoped>
/* #sideNav .el-menu-item{
        text-align:left
    } */
</style>
